export const extractDate = (date) => {
    const pattern = /(\w+)\s(\d{1,2})\s(\w+)\s(\d{4})/;
    const match = date === null || date === void 0 ? void 0 : date.match(pattern);
    if (match) {
        return {
            day: match[1],
            dayNumber: parseInt(match[2]) > 9 ? match[2] : "0" + match[2],
            month: match[3],
            year: match[4],
        };
    }
    return null;
};
export const getExactDate = (date) => {
    const dateObj = new Date(date);
    const month = dateObj.getMonth() + 1;
    const day = String(dateObj.getDate());
    const year = dateObj.getFullYear();
    return { day, month, year };
};
export const extractDateWithTime = (dateTime) => {
    const pattern = /(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2})/;
    const match = dateTime === null || dateTime === void 0 ? void 0 : dateTime.match(pattern);
    if (match) {
        const hours = parseInt(match[4]);
        const minutes = parseInt(match[5]);
        return {
            year: match[1],
            month: match[2],
            day: match[3],
            time: hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59
                ? `${match[4]}:${match[5]}`
                : null,
        };
    }
    return null;
};
export const getMonthlyIncrementsUntilCurrent = (dateStr) => {
    const startDate = new Date(dateStr);
    if (isNaN(startDate.getTime())) {
        throw new Error("Invalid date string provided.");
    }
    const currentDate = new Date();
    const monthlyIncrements = [];
    let iterDate = new Date(startDate);
    while (iterDate.getFullYear() < currentDate.getFullYear() ||
        (iterDate.getFullYear() === currentDate.getFullYear() &&
            iterDate.getMonth() <= currentDate.getMonth())) {
        // Set day to 1st to avoid month skipping on increment
        iterDate.setDate(1);
        const formattedDate = `${iterDate.getFullYear()}-${String(iterDate.getMonth() + 1)}`;
        monthlyIncrements.push(formattedDate);
        iterDate.setMonth(iterDate.getMonth() + 1);
    }
    return monthlyIncrements;
};
export const parseDisplayDate = (displayDate) => {
    const months = {
        Jan: 1,
        Feb: 2,
        Mar: 3,
        Apr: 4,
        May: 5,
        Jun: 6,
        Jul: 7,
        Aug: 8,
        Sep: 9,
        Oct: 10,
        Nov: 11,
        Dec: 12,
    };
    const parts = displayDate.trim().split(" ");
    if (parts.length !== 4) {
        throw new Error('Invalid format. Expected format: "Weekday DD MMM YYYY"');
    }
    const [weekday, dayStr, monthStr, yearStr] = parts;
    const day = parseInt(dayStr, 10);
    const month = months[monthStr];
    const year = parseInt(yearStr, 10);
    return { day, month, year };
};
export var Month;
(function (Month) {
    Month[Month["january"] = 1] = "january";
    Month[Month["february"] = 2] = "february";
    Month[Month["march"] = 3] = "march";
    Month[Month["april"] = 4] = "april";
    Month[Month["may"] = 5] = "may";
    Month[Month["june"] = 6] = "june";
    Month[Month["july"] = 7] = "july";
    Month[Month["august"] = 8] = "august";
    Month[Month["september"] = 9] = "september";
    Month[Month["october"] = 10] = "october";
    Month[Month["november"] = 11] = "november";
    Month[Month["december"] = 12] = "december";
})(Month || (Month = {}));
export const convertToClientTimeZone = ({ date, timezone, }) => {
    if (!date || !timezone) {
        return undefined;
    }
    let originalDate;
    if (typeof date === "string") {
        originalDate = new Date(date);
    }
    else if (date instanceof Date) {
        originalDate = date;
    }
    else {
        return undefined; // Invalid date input type
    }
    if (isNaN(originalDate.getTime())) {
        return undefined; // Invalid date string or object
    }
    // Get the UTC time in milliseconds
    const utcTime = originalDate.getTime();
    const offset = timezone.split(":");
    let offsetMilliseconds = 0;
    if (offset.length === 3) {
        offsetMilliseconds =
            parseInt(offset[0]) * 60 * 60 * 1000 +
                parseInt(offset[1]) * 60 * 1000 +
                parseInt(offset[2]) * 1000;
    }
    else if (offset.length === 2) {
        offsetMilliseconds =
            parseInt(offset[0]) * 60 * 60 * 1000 +
                parseInt(offset[1]) * 60 * 1000;
    }
    else {
        throw new Error("Invalid timezone offset");
    }
    const adjustedDate = new Date(utcTime + offsetMilliseconds);
    return adjustedDate === null || adjustedDate === void 0 ? void 0 : adjustedDate.toISOString().replace("T", " ").replace("Z", "").slice(0, -4);
};
